"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeApplication_de_de = void 0;
function backofficeApplication_de_de() {
    return {
        "backoffice.applications.navigation.linkeddomains": "Verknüpfte Domains",
        "backoffice.applications.navigation.details": "Details",
        "backoffice.applications.navigation.content": "Inhalt",
        "backoffice.applications.navigation.theme": "Design",
        "backoffice.applications.navigation.preview": "Preview",
        "backoffice.applications.configurations.authorizationtypes.customers": "Kunden",
        "backoffice.applications.configurations.authorizationtypes.backofficeusers": "Mitarbeiter",
        "backoffice.applications.subtitle": "Eigene Applikationen erstellen und als Webseite anbieten.",
        "backoffice.applications.all": "alle Applikationen",
        "backoffice.applications.domains.remove.buttontext": "Domain entfernen",
        "backoffice.applications.domains.confirmremovetitle": "Domain ${domain} entfernen?",
        "backoffice.applications.domains.confirmremovecontent": "Wollen Sie die Domain ${domain} wirklich entfernen? Ihre Applikation wird danach nicht mehr über diese Domain verfügbar sein.",
        "backoffice.applications.errors.domainalreadyadded": "Diese Domain wurde bereits hinzugefügt!",
        "backoffice.applications.errors.domainalreadyverifiedinotherapplication": "Diese Domain wurde bereits von einer anderen Applikation hinzugefügt und verifiziert!",
        "backoffice.applications.errors.verificationfailed": "Leider ist die Überprüfung Ihrer Domain fehlgeschlagen"
    };
}
exports.backofficeApplication_de_de = backofficeApplication_de_de;
